import {FormulaMetric} from 'app_api/projects/metrics/types';
import {useMetrics} from 'common/contexts/react/metrics-resource-context';
import {Translatable} from 'common/i18n';
import {MetricType, TopLevelMetricType} from 'common/types/reports/bookmark';
import {ICON_MAPPING} from 'common/query-builder/query-entry-section/util/entry-icon';

import {FormulaSectionItem, MenuType, MultiMetricsSection} from '../multi-metrics-menu/types';
import {FormulaMenuItemValue} from './types';

function getFormulaMenuItem(metric: FormulaMetric): FormulaSectionItem {
  return {
    icon: ICON_MAPPING[MetricType.Formula],
    label: metric.name,
    menuType: MenuType.Formula,
    value: metric,
  };
}

export function getFormulaSection({
  label,
  savedFormulas,
  isRecentSection = false,
}: {
  label: Translatable;
  savedFormulas: FormulaMetric[];
  isRecentSection?: boolean;
}): MultiMetricsSection<FormulaMenuItemValue> {
  return {
    label,
    isRecentSection,
    items: savedFormulas.map(getFormulaMenuItem),
  };
}

export function getFormulaSections({
  recentFormulaMenuItems,
  savedFormulas,
}: {
  recentFormulaMenuItems: FormulaMenuItemValue[];
  savedFormulas: FormulaMetric[];
}): Array<MultiMetricsSection<FormulaMenuItemValue>> {
  if (savedFormulas.length) {
    const recentFormulas = savedFormulas.filter((formula) =>
      recentFormulaMenuItems.some((item) => item.id === formula.id),
    );

    const showRecents = savedFormulas.length > 6 && recentFormulas.length > 0;
    return [
      /** only disply a recently used section when there are enough items to fill in the dropdown */
      getFormulaSection({
        label: ({t}) => t(`query-builder.multi-metrics-menu.section-recents`),
        savedFormulas: showRecents ? recentFormulas : [],
        isRecentSection: true,
      }),
      getFormulaSection({
        label: ({t}) => t(`query-builder.multi-metrics-menu.section-formulas`),
        savedFormulas,
      }),
    ].filter(Boolean);
  }
  return [];
}

export function useSavedFormulas(): FormulaMetric[] {
  const metrics = useMetrics();
  return metrics
    .getAllValues()
    .filter((metric) => metric.type === TopLevelMetricType.Formula && metric.can_view) as FormulaMetric[];
}
